var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-icon',{staticClass:"d-flex justify-center flex-column",attrs:{"color":_vm.color ? _vm.color : 'secondary',"size":_vm.$vuetify.breakpoint.smAndDown ? Math.round(_vm.size - (_vm.size * 0.33)) : _vm.size}},[_vm._v(" mdi-"+_vm._s(_vm.icon)+" ")]),_c('p',{class:[
    'text-center',
    ("" + (_vm.$vuetify.breakpoint.smAndDown ? 'subtitle-1' : 'title')),
    'ma-0',
    'font-weight-bold',
    ((_vm.color ? _vm.color : 'primary') + "--text")
  ]},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{class:[
    'text-center',
    ("" + (_vm.$vuetify.breakpoint.smAndDown ? 'caption' : 'body-2')),
    'font-weight-light',
    ((_vm.color ? _vm.color : 'secondary') + "--text")
  ],attrs:{"pa-1":""}},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }